import { ViewType } from "in_queue/components/tables/ribbon/ViewTypesMenu";
import { useSubscriptionForCluster } from "in_queue/contexts/ProjectDataContext";
import { useEffect, useState } from "react";

export const useScenarioResultValidViewTypes = () => {
    const subscription = useSubscriptionForCluster();
    const [validViewTypes, setValidViewTypes] = useState<ViewType[]>([
        "current",
        "related"
    ]);

    useEffect(() => {
        // If the subscription has unlimited projects, we can show all scenario results
        if (subscription !== "loading" && subscription?.projectLimit === null) {
            setValidViewTypes(["current", "related", "all"]);
        }
    }, [subscription]);

    return validViewTypes;
};
